export default {
    path: '/notifications',
    component: () => import('../views/Global/NotificationsView.vue'),
    meta: {
        title: 'NOTIFICATIONS',
        private: true,
    },
    children: [
        {
            path: '',
            name: 'notifications',
            component: () => import('@/components/Notifications/Notifications.vue'),
        },
    ],
};
